<template>
  <div class="publicizeList">
    <div class="banner">
      <img :src="bannerStr" alt="">
      <div class="weizhi ovHide">
        <i class="iconfont icon-dizhi"></i> 当前位置：{{bannerTex}} > {{detail.title}}
      </div>
    </div>
    <div class="bgc">
      <div class="bx-content">
        <div class="back">
          <b></b>
          <span @click="$router.go(-1)">
            <i class="iconfont icon-prev_arrow-copy"></i>返回
          </span>
        </div>

        <div class="list-box">
          <div class="title">{{detail.title}}</div>

            <div class="flex justify-center align-center desc">
              <div class="time" v-if="detail.author">
                <i class="iconfont icon-zuozhe"></i>
                作者：{{detail.publish_time}}
              </div>
              <div class="time">
                <i class="iconfont icon-shijian6"></i>
                时间：{{detail.publish_time}}
              </div>
              <div class="time" v-if="detail.resource">
                <i class="iconfont icon-laiyuan1"></i>
                来源：{{detail.resource}}
              </div>
            </div>

<!--          <div class="time">-->
<!--            <i class="iconfont icon-shijian5"></i>-->
<!--            时间：{{detail.publish_time}}-->
<!--          </div>-->

          <div class="content" v-html="detail.content"></div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
import {
  masses_article_detail
} from "@/api";
export default {
  name: "policyList",
  data() {
    return {
      id: '',
      type: '',
      bannerTex:'',
      bannerStr:'',
      detail:{
        title: '',
        resource: '',
        author: '',
        publish_time: '',
        content: ''
      }
    }
  },
  components: {},
  created() {
    this.id = this.$route.query.id
    this.type = this.$route.query.type
    this.bannerFun()
    this.init()
  },
  methods: {
    async init(){
      let _data = await masses_article_detail(this.id);
      if(_data.status == 200) {
        this.detail = _data.data
      }
    },
    bannerFun(){
      switch (Number(this.type)) {
        case 1:
          this.bannerTex = '首页 > 政策法规'
          this.bannerStr = require('@/assets/images/zhengcefagui.jpg')
          break;
        case 3:
          this.bannerTex = '首页 > 宣传信息'
          this.bannerStr = require('@/assets/images/xuanchuanxinxi.jpg')
          break;
        case 5:
          this.bannerTex = '首页 > 科技专栏'
          this.bannerStr = require('@/assets/images/kejizhuanlan.jpg')
          break;
          default:
            this.bannerTex = '首页 > 详情'
            this.bannerStr = require('@/assets/images/indexbanner.jpg')
            break;
      }
    },
  },
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.publicizeList {
  .bgc {
    width: 100%;
    padding-bottom: 50px;
    background-image: linear-gradient(0deg,
      #ffffff 0%,
      #ebf4ff 100%);
    .list-box {
      width: 100%;
      background: #ffffff;
      box-shadow: 11px 8px 18px 0px
      rgba(0, 46, 108, 0.17);
      border-radius: 8px;
      border: solid 1px #ffffff;
      padding: 80px 30px;
      .content {
        width: 100%;
        padding: 50px 100px;
        font-size: 18px;
        color: #333640;
        line-height: 30px;
        img {
          max-width: 100%;
          display: block;
          margin: 10px auto;
        }
      }
      .title {
        width: 100%;
        text-align: center;
        font-size: 36px;
        color: #293340;
      }
      .desc {
        width: 100%;
        height: 90px;
        border-bottom: 1px solid #cecece;
        border-top: 1px solid #cecece;
        margin-top: 30px;
        .time {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: #000000;
          padding: 0 15px;
          i {
            font-size: 23px;
            color: #000000;
            margin-right: 4px;
          }
        }
      }

    }
    .back {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
      span {
        font-size: 18px;
        color: #428ffb;
        width: 105px;
        height: 45px;
        border-radius: 22px;
        border: solid 1px #428ffb;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        i {
          font-size: 20px;
          margin-right: 5px;
          color: #428ffb;
        }
      }
    }
  }
  .banner {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      height: auto;
    }
    .weizhi {
      width: 1500px;
      position: absolute;
      bottom: 20px;
      left: 50%;
      padding-right: 900px;
      margin-left: -750px;
      font-size: 18px;
      letter-spacing: 1px;
      color: #ffffff;
      i {
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
}
</style>


